// ./gatsby-browser.js
import './src/styles/global.scss';

// Import development helpers to make them available in browser console
import './src/utils/developmentHelpers';

// The following line of code is the same as the one in gatsby-ssr.js and retrieves shared code from the wrap-with-provider.js file.
export { wrapRootElement } from "./src/wrap-with-provider";

// GA4/GTM: Push page metadata on every SPA route change so GTM can
// attribute pageviews with correct URL and title information.
// Note: gatsby-plugin-google-tagmanager also fires a bare gatsby-route-change
// event, but without page_location/page_path/page_title. Our push adds those.
export const onRouteUpdate = () => {
  setTimeout(() => {
    if (typeof window !== 'undefined') {
      const { trackPageView } = require('./src/utils/tracking');
      trackPageView();
    }
  }, 50);
};
